<template>
  <div class="form-group">
    <label>
      <span v-text="formatLabel()" />
      <!--suppress JSUnresolvedVariable -->
      <input
        :id="`form-field-${name}`"
        v-model="mutableValue"
        v-validate="validation"
        v-bind="actions"
        :data-vv-name="`form-field-${name}`"
        :data-vv-as="formatLabel()"
        :title="formatLabel()"
        :class="{'is-danger': errors.has(`form-field-${name}`)}"
        type="text"
        class="form-control"
        @input="$emit('input', mutableValue)"
      >
    </label>
    <span
      v-if="errors.has(`form-field-${name}`)"
      class="has-error"
      v-text="errors.first(`form-field-${name}`)"
    />
    <span
      v-if="info"
      class="help-block"
      v-text="info"
    />
  </div>
</template>

<script>
import Field from '../field.vue';

export default {
  extends: Field,
};
</script>
